module.exports = __webpack_public_path__ + "templates.customer_cancel_order-confirm-modal-80bfcd3d.html";